<template>
  <div id="app">
    <header v-if="isAuthenticated" class="header">
      <appHeader />
    </header>

    <div class="content">
      <router-view />
    </div>

    <footer class="footer">
      <appFooter />
    </footer>

    <go-top :boundary="250" :max-width="320" weight="bold" />

    <appLoaderOverlay />
  </div>
</template>

<script>
import GoTop from "@inotom/vue-go-top";

import appHeader from "@/components/Header";
import appFooter from "@/components/Footer";
// import invitationPdf from "@/documents/convocation/convocation";
// import orderPdf from "@/documents/order/order";
// import pouvoirPdf from "@/documents/pouvoir/pouvoir";
// import vbcPdf from "@/documents/vbc/vbc";

export default {
  components: {
    appHeader,
    appFooter,
    GoTop,
    // invitationPdf,
    // orderPdf,
    // pouvoirPdf,
    // vbcPdf,
  },
  computed: {
    isAuthenticated() {
      var isAuthenticated = this.$store.getters["auth/isAuthenticated"];
      if (!isAuthenticated) {
        localStorage.clear();
      }
      return isAuthenticated;
    },
  },
  watch: {
    isAuthenticated(newVal) {
      if (newVal) {
        this.$store.dispatch("getCountries");
      }
    },
  },
  async created() {
    if (this.isAuthenticated) {
      await this.$store.dispatch("getCountries");
    }
  },
};
</script>

<style lang="scss">
// import Bootstrap and BootstrapVue scss files
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/src/index.scss";
@import "~bootstrap-icons/font/bootstrap-icons.css";

// import other packages style files
@import "~vue-select/src/scss/vue-select.scss";
@import "~vue-multiselect/dist/vue-multiselect.min.css";
@import "~pretty-checkbox/src/pretty-checkbox.scss";

// import main scss file last
@import "@/assets/scss/main";
</style>
